import React, { useState } from 'react';
import useScrapeSite from '../hooks/useScrapeSite';
import { useAuth } from '../hooks/auth';
import { saveScrapedData } from '../hooks/useScrapeSite';

const MyComponent = () => {
  const [url, setUrl] = useState('');
  const { content, loading } = useScrapeSite(url);
  const { user } = useAuth(); // Get the authenticated user

  const handleSubmit = async (e) => {
    e.preventDefault();
    const inputUrl = e.target.elements.url.value;
    setUrl(inputUrl);

    // When content is ready, save it to the database
    if (content && user) {
      await saveScrapedData(user.uid, content);
    }
  };

  return (
    <div style={{ color: 'white', padding: '20px', fontFamily: 'Arial' }}>
      <h1>Scrapping Page</h1>
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <label>
          Enter URL to Scrape:
          <input
            type="text"
            name="url"
            placeholder="Enter URL..."
            style={{
              color: 'black',
              marginLeft: '10px',
              padding: '5px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              width: '300px',
            }}
          />
        </label>
        <button
          type="submit"
          style={{
            marginLeft: '10px',
            padding: '5px 10px',
            borderRadius: '5px',
            border: 'none',
            cursor: 'pointer',
            background: '#007bff',
            color: 'white',
          }}
        >
          Scrape
        </button>
      </form>
      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
          backgroundColor: '#333',
          overflowY: 'scroll',
          maxHeight: '80vh',
        }}
      >
        {loading ? 'Loading...' : content}
      </div>
    </div>
  );
};

export default MyComponent;
